let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("d4kiK")).then(() => parcelRequire('cb2XJ'));